import { render, staticRenderFns } from "./EmployeeBadge.vue?vue&type=template&id=125c7dd6"
import script from "./EmployeeBadge.vue?vue&type=script&lang=js"
export * from "./EmployeeBadge.vue?vue&type=script&lang=js"
import style0 from "./EmployeeBadge.vue?vue&type=style&index=0&id=125c7dd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports